import React from 'react';

interface DefaultAvatarIconProps {
  className?: string;
  width?: number;
  height?: number;
  name?: string;
}

const DefaultAvatarIcon: React.FC<DefaultAvatarIconProps> = ({
  className = '',
  width = 85,
  height = 85,
  name,
}) => {
  const bgColors = ['#A772FF', '#FFCA2C', '#FF682C', '#A3ED34', '#39D6B7', '#2CABFF', '#DF44A9', '#FF4677'];
  
  // 根据name计算hash值
  const getHashFromString = (str: string): number => {
    let hash = 0;
    if (!str) return 0;
    
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // 转换为32位整数
    }
    
    return Math.abs(hash);
  };
  
  // 根据hash值选择背景颜色
  const getBackgroundColor = () => {
    const hash = getHashFromString(name || '');
    const index = hash % bgColors.length;
    return bgColors[index];
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 85 85"
      className={className}
    >
      {/* 添加圆形背景 */}
      <circle cx="42.5" cy="42.5" r="42.5" fill={getBackgroundColor()} />
      <path fillRule="evenodd" clipRule="evenodd" d="M71 43H15V55H19V59H23V63H31V67H55V63H63V59H67V55H71V43Z" fill="white"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M23 23H19V27V31V35V39V43H35V47H51V43H67V39V35V31V27V23H63V27H59V31H51V27H35V31H27V27H23V23Z" fill="#D49301"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M19 19H23V23H19V19ZM15 43V23H19V43H15ZM15 55H11V43H15V55ZM19 59H15V55H19V59ZM23 63H19V59H23V63ZM31 67H23V63H31V67ZM55 67V71H31V67H55ZM63 63V67H55V63H63ZM67 59V63H63V59H67ZM71 55V59H67V55H71ZM71 43H75V55H71V43ZM67 23H71V43H67V23ZM63 23V19H67V23H63ZM59 27V23H63V27H59ZM51 27H59V31H51V27ZM35 27V23H51V27H35ZM27 27H35V31H27V27ZM27 27V23H23V27H27ZM35 56H39V60H35V56ZM35 56H31V52H35V56ZM47 60V64H39V60H47ZM47 56V60H51V56H55V52H51V56H47ZM47 56V49H39V56H47ZM27 40H35V47H27V40ZM59 40H51V47H59V40Z" fill="black"/>
      <rect x="35" y="36" width="4" height="4" fill="white"/>
      <rect x="47" y="36" width="4" height="4" fill="white"/>
      <rect x="39" y="56" width="8" height="4" fill="#F5433F"/>
    </svg>
  );
};

export default DefaultAvatarIcon;
